import { TelemetryEvent } from '../../utilities/insights/models/telemetry-event';

export class ApplicationStartEvent extends TelemetryEvent {
	constructor() {
		super('application-start');
	}
}

